export default "__VITE_ASSET__CIYL0rep__"